export default {"src":"/_next/static/media/chevron-up.fe1ec518.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};